interface InterviewProgressProps {
	currentQuestionIndex: number;
	totalQuestions: number;
	answeredCount: number;
}

/**
 * Progress indicator for the sequential interview.
 *
 * Thin full-width progress bar only — no pills, no text, no counters.
 */
export function InterviewProgress({
	currentQuestionIndex: _currentQuestionIndex,
	totalQuestions,
	answeredCount,
}: InterviewProgressProps) {
	const progressPercent =
		totalQuestions > 0 ? (answeredCount / totalQuestions) * 100 : 0;

	return (
		<div className="h-1 w-full bg-muted overflow-hidden">
			<div
				className="h-full bg-primary transition-all duration-500"
				style={{ width: `${progressPercent}%` }}
			/>
		</div>
	);
}
